/**
 * Recently viewed products stored in localStorage (theme-only; stores handles).
 */
export class RecentlyViewed {
  /** The key used to store the viewed product handles in localStorage */
  static #STORAGE_KEY = 'viewedProductHandles';
  /** The maximum number of products to store */
  static #MAX_PRODUCTS = 8;

  /**
   * Adds a product handle to the recently viewed products list.
   * Backward-compat: if an ID is accidentally passed, it will be ignored (no mapping without API).
   * @param {string} productHandle - The product handle to add (e.g., "my-product").
   */
  static addProduct(productHandle) {
    if (typeof productHandle !== 'string') return;
    // Heuristic: handles are usually lowercase and contain hyphens; guard against numeric IDs
    const handle = productHandle.trim();
    if (!handle || /^\d+$/.test(handle)) return; // ignore numeric IDs

    let handles = this.getProducts();
    handles = handles.filter((/** @type {string} */ h) => h !== handle);
    handles.unshift(handle);
    handles = handles.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(handles));
    } catch (_) {
      // storage might be full; best effort: drop oldest and retry once
      handles = handles.slice(0, Math.max(0, this.#MAX_PRODUCTS - 1));
      try { localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(handles)); } catch (_) {}
    }
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed product handles from localStorage.
   * @returns {string[]} The list of viewed product handles.
   */
  static getProducts() {
    try {
      const raw = localStorage.getItem(this.#STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter((h) => typeof h === 'string' && h) : [];
    } catch {
      return [];
    }
  }
}
